import { Skeleton } from './skeleton';

export function PageSkeleton(): React.ReactElement {
  return (
    <div className="mx-auto max-w-7xl px-4 py-8">
      {/* Titulo */}
      <Skeleton className="mb-6 h-10 w-72" />

      {/* Parrafo introductorio */}
      <div className="mb-8 space-y-3">
        <Skeleton className="h-4 w-full" />
        <Skeleton className="h-4 w-5/6" />
        <Skeleton className="h-4 w-4/6" />
      </div>

      {/* Grid de cards */}
      <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
        {Array.from({ length: 6 }).map((_, i) => (
          <div key={i} className="rounded-xl border p-6">
            <Skeleton className="mb-4 h-6 w-40" />
            <Skeleton className="mb-2 h-4 w-full" />
            <Skeleton className="h-4 w-3/4" />
          </div>
        ))}
      </div>
    </div>
  );
}
